import { CODInput } from "../../ui/CODinput";

const CustomerView = ({ customerData }) => {
    return (
        <>
            <p>CreatedBy: {customerData.createdBy} <br /><span style={{color: "#000", fontSize: "12px"}}> CreatedAt: {customerData.createdAt} </span> </p>
            <p>UpdatedBy: {customerData.updatedBy} <br /><span style={{color: "#000", fontSize: "12px"}}> UpdatedAt: {customerData.updatedAt} </span></p>
            <form style={{ width: "100%", padding: "10px", maxHeight: "500px", overflow: "auto" }} onSubmit={(e) => {e.preventDefault()}}>
             
                <h4 style={{color: "#07b1b0", margin:"0", marginTop:"10px"}}>Company Details</h4>
                <CODInput
                    label="Company Name"
                    type="text"
                    name="customerName"
                    value={customerData.customerName}
                    disabled={true}
                    required
                />
                <hr />
                <h4 >Company Address</h4>
                <CODInput
                    label="Address Line 1 "
                    type="text"
                    name="address1"
                    value={customerData.address1}
                    disabled={true}
                />
                <CODInput
                    label="Address Line 2 "
                    type="text"
                    name="address2"
                    value={customerData.address2}
                    disabled={true}
                />
                <CODInput
                    label="Address Line 3"
                    type="text"
                    name="address3"
                    value={customerData.address3}
                    disabled={true}
                />
                <CODInput
                    label={"City"}
                    type={"text"}
                    name={"city"}
                    disabled={true}
                    value={customerData.city}
                />
                <CODInput
                    label="Post Code"
                    type="text"
                    name="postCode"
                    value={customerData.postCode}
                    disabled={true}
                />
                <CODInput
                    label="State/Province "
                    type="text"
                    name="state"
                    value={customerData.state}
                    disabled={true}
                />
                <CODInput
                    label="Country"
                    type="text"
                    name="country"
                    value={customerData.country}
                    disabled={true}
                />
                <hr />
                <h4 style={{color: "#07b1b0"}}>Admin User</h4>
                <CODInput
                    label="Email Address"
                    type="text"
                    name="adminUserEmail"
                    value={customerData.adminUserEmail}
                    disabled={true}
                />
                <CODInput
                    label="Company Domain(s)"
                    type="text"
                    name="domains"
                    value={customerData.domains}
                    disabled={true}
                />
                <h4 style={{color: "#07b1b0"}}>Subscription Plan</h4>
                <CODInput
                    label="Subscription Plan "
                    type="text"
                    name="subscriptionPlan"
                    value={customerData.subscriptionPlan}
                    disabled={true}
                />
                <CODInput
                    label="Start Date "
                    type="text"
                    name="startDate"
                    value={customerData.customerStartDate}
                    disabled={true}
                />
                <CODInput
                    label="End Date "
                    type="text"
                    name="endDate"
                    value={customerData.customerEndDate}
                    disabled={true}
                />
                <hr />
                <h4 style={{color: "#07b1b0"}}>Company Preferences</h4>
                <CODInput
                    label="Logo URL "
                    type="text"
                    name="url"
                    value={customerData.logoUrl}
                    disabled={true}
                />
                <CODInput
                    label="Primary Color "
                    type="text"
                    name="primaryColor"
                    value={customerData.masterColor}
                    disabled={true}
                />
                <CODInput
                    label="Secondary Color "
                    type="text"
                    name="secondaryColor"
                    value={customerData.secondaryColor}
                    disabled={true}
                />
                <CODInput
                    label="Tertiary Color "
                    type="text"
                    name="tertiaryColor"
                    value={customerData.tertiaryColor}
                    disabled={true}
                />
            </form>
        </>
    );
};

export default CustomerView;